import { AlertMessage } from "../component/common/Alert"
import { basePort, headers, setCookie, getJwtFromCookies, getRoleJwt, renderRedirect } from "../module_auth/AuthService"
import { useState, useEffect } from 'react';

export function FindPwd() {
    const [email, setEmail] = useState("");
    const [fullname, setFullname] = useState("");
    const [validationCode, setValidationCode] = useState("");

    const [showMessage, setShowMessage] = useState(false);
    const [disableValidationBtn, setDisableValidationBtn] = useState(false);
    const [disableSubmitBtn, setDisableSubmitBtn] = useState(true);

    const [message, setMessage] = useState("");

    function handleEmail(event) {
        //setShowAlert(false)
        setEmail(event.target.value)
    }

    function handleFullname(event) {
        //setShowAlert(false)
        setFullname(event.target.value)
    }

    function handleValidationCode(event) {
        //setShowAlert(false)
        setValidationCode(event.target.value)
    }

    function clickSendValidationCode(event) {
        event.preventDefault();
        const jwtRequest = {
            email:email,
            fullname:fullname,
        }

        fetch(basePort + '/sendValidationCodePwd', 
            {method:'post', headers, body:JSON.stringify(jwtRequest)})
                .then(response => response.json())
                .then(response   => {
                    setMessage(response.validationMessage)
                    setShowMessage(true)
                    if(response.validRequest){
                        setDisableValidationBtn(true)
                        setDisableSubmitBtn(false)
                    }
            }).catch(error => console.log(error))
    }

    function clickSubmit(event) {
        event.preventDefault();
        const jwtRequest = {
            email:email,
            fullname:fullname,
            validationCode:validationCode,
        }
        fetch(basePort + '/resetPassword', 
            {method:'post', headers, body:JSON.stringify(jwtRequest)})
                .then(response => response.json())
                .then(response   => {
                    setMessage(response.validationMessage)
                    setShowMessage(true)
                    if(response.validRequest){
                        setDisableSubmitBtn(true)
                    }
            }).catch(error => console.log(error))
    }

    return (
        <div>
            <main class="page lanidng-page">
                <section>
                    <div class="container" style={{paddingTop:'100px', marginTop: '10px', marginBottom: '10px'}}>
                        <div class="row mb-5">
                            <div class="col-md-8 col-xl-6 text-center mx-auto">
                                <h2 style={{fontFamily: 'Nanum Gothic'}}>비밀번호 찾기</h2>
                                <p></p>
                            </div>
                        </div>
                        <div class="row d-flex justify-content-center">
                            <div class="col-md-6 col-xl-4" style={{width: '600px'}}>
                                <div class="card mb-5">
                                    <div class="card-body d-flex flex-column align-items-center">
                                        <form class="text-center" method="post">
                                            <div class="mb-3"><input class="form-control" type="email" name="email" placeholder="이메일" onChange={handleEmail}/></div>
                                            <div class="mb-3"><input class="form-control" type="text" placeholder="이름" onChange={handleFullname}/></div>
                                            <div class="mb-3"><button class="btn btn-secondary d-block w-100" type="submit" onClick={clickSendValidationCode} disabled={disableValidationBtn}>인증번호 보내기</button></div>
                                            <div class="mb-3"><input class="form-control" type="text" placeholder="인증번호 숫자 6자리" onChange={handleValidationCode}/></div>
                                            <div class="mb-3"><button class="btn btn-primary d-block w-100" type="submit" onClick={clickSubmit} disabled={disableSubmitBtn}>확인</button></div>
                                        </form>
                                        <AlertMessage show={showMessage} msg={message} />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </main>
        </div>
    );
}